import React, { useState, useEffect } from "react"
import Modal from "react-bootstrap/lib/Modal"
import OrderByList from "../OrderByList"
import SectionsList from "../SectionsList"
import ServicesSearch from "../ServicesSearch"
import { ALL_CATEGORIES } from "../VenueServicesList"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function InlineSectionsFilter(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    handleSearch,
    sections,
    sortElement,
    selectedSection,
    onSectionClick,
    onOrderByClick,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [isModalVisible, setIsModalvisible] = useState(false)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleSectionClick(section) {
    setIsModalvisible(false)
    onSectionClick(section)
  }

  function handleSort(sortFunction) {
    setIsModalvisible(false)
    onOrderByClick(sortFunction)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={`${style.container} ${props.className}`}>
      <ServicesSearch handleSearch={handleSearch} hasTitle={false} />

      <div className={style.filtersContainer}>
        <div
          className={style.element}
          onClick={() => setIsModalvisible("sections")}
        >
          <div className={style.sectionContainer}>
            {I18n.t("service_ordering.categories_filtering")}
            <i className={`fal fa-angle-down ${style.downIcon}`}></i>
          </div>
        </div>
        <div
          className={style.element}
          onClick={() => setIsModalvisible("ordering")}
        >
          <div className={style.sectionContainer}>
            {I18n.t("service_ordering.ordering_title")}
            <i className={`fal fa-angle-down ${style.downIcon}`}></i>
          </div>
        </div>
      </div>

      <Modal
        show={!!isModalVisible}
        onHide={() => setIsModalvisible(false)}
        onExited={() => setIsModalvisible(false)}
        className="modal modal--full-height venue-categories-modal"
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isModalVisible === "sections"
              ? I18n.t("pages.locations.venues.cuisines.title")
              : I18n.t("service_ordering.ordering_title")}
          </Modal.Title>
          <div
            className="close-container"
            onClick={() => {
              setIsModalvisible(false)
            }}
          >
            <i className="fas fa-times-circle icon"></i>
          </div>
        </Modal.Header>
        <Modal.Body>
          {isModalVisible === "sections" && (
            <SectionsList
              sections={sections}
              selectedSection={selectedSection}
              onClick={handleSectionClick}
            />
          )}
          {isModalVisible !== "sections" && (
            <OrderByList
              handleSort={handleSort}
              currentSortElement={sortElement}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default InlineSectionsFilter
